import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import Snackbar from '@mui/material/Snackbar';
import Box from '@mui/material/Box';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LinearProgress from '@mui/material/LinearProgress';
import Chip from '@mui/material/Chip';
import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Carrier from '../../pages/General/Carrier'
import Notification from '../../pages/General/Notification'
import NorowsData from '../../pages/General/NorowsData'
import Printer from '../../pages/General/Printer'
import { doGetRate, resetRateState } from '../../pages/Shipments/NewShipment/rateSlice';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { generateLabel, resetGenerateLabel } from '../../pages/Shipments/NewShipment/createShipmentSlice';
import { dopostDataCreateShipment } from '../../pages/Orders-new/ordersSlice';

const RateDrawer = ({ visible, reportName, formDataValues, onClose, newOrderFormData, meta, isDuplicateOrder,isReturnOrder, lineItemId, customLineItems, setValues,setNewOrderFormData, setCustomLineItems, setRateDrawervisible = () => { }, setNewOrderCreateDrawerVisible = () => { },isFailedShipment=false,isShipmentCreationFlow=false }) => {
    const dispatch = useDispatch();
    const orders = useSelector(state => state.ordersNew.createShipment);
    const rates = useSelector(state => state.rates);
    const profile = useSelector(state => state.auth);
    const createshipment = useSelector(state => state.createshipment);
    const alternateLocationData = useSelector(state => state.rates?.alternateLocationData);
    const [rateData, setRateData] = useState([]);
    const [labelShowData, setLabelShowData] = useState(false);
    const [drawer, setDrawer] = useState(true);
    const [snackOpen, setsnackOpen] = useState(false);
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [isLabelOpened, setIsLabelOpened] = useState(true)
    const [isFailedLabelPrinted, setIsFailedLabelPrinted] = useState(true)
    const initialFValues = {
        name: '',
        company: '',
        phone: '',
        email: '',
        address: '',
        address2: '',
        city: '',
        postal_code: '',
        country_code: '',
        weight: '',
        box_weight: '',
        actual_weight: '',
        province: '',
        preferred_sender_id: '',
        length: '',
        height: '',
        width: '',
        dimension_unit: 'in',
        weight_unit: 'lb',
        insurance_amount: "",
        choosemeasurement: '',
        preferred_carrier: '',
        preferred_carrier_reference_id: '',
        preferred_service: '',
        sender_reference_no:'',
        return_shipment_sender_id:"",
        shipment_type:"PACKAGE",
        is_signature_required:"",
    }
    const ondrawerclose = () => {
        setDrawer(false)
        onClose(false)
        // dispatch(resetRateState())
        dispatch(resetGenerateLabel())
    }

    const toggleDrawer = (anchor, open) => (event) => {
        let hidedrawer = ''
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
    };

    useEffect(() => {
        if (rates && rates.message && rates.message.length !== 0) {
            setsnackOpen(true)
        }
    }, [rates]);

    const handleClose = () => {
        dispatch(resetRateState())
        setsnackOpen(false)
    };

    function generateCustomRef() {
        // Generate a 24-character hex string
        const randomHex = [...Array(24)]
          .map(() => Math.floor(Math.random() * 16).toString(16))
          .join('');
      
        // Get current datetime in YYYYMMDDHHmmss format
        const now = new Date();
        const datetime =
          now.getFullYear().toString() +
          String(now.getMonth() + 1).padStart(2, '0') +
          String(now.getDate()).padStart(2, '0') +
          String(now.getHours()).padStart(2, '0') +
          String(now.getMinutes()).padStart(2, '0') +
          String(now.getSeconds()).padStart(2, '0');
        // Combine everything
        return `SCREF${randomHex}${datetime}`;
      }

    const generatelabel = (rate_row,status) => {
        let apikey = (profile.profile.api_token) ? profile.profile.api_token : "";
        const formData = formDataValues;
        let referenceno = ""
        let preferred_carrier = ""
        let fetch_rate_request_id=""
        fetch_rate_request_id=rates && rates.data && rates.data.fetch_rate_request_id ? rates.data.fetch_rate_request_id :""
        if(!isDuplicateOrder && newOrderFormData && newOrderFormData.reference && newOrderFormData.reference.no){
            referenceno = newOrderFormData.reference.no
        }

        let order_id_check=""
        let document_reference={}
        if(isReturnOrder){
            order_id_check=(newOrderFormData && newOrderFormData.order && newOrderFormData.order.id)
                ? "R"+newOrderFormData.order.id : ""
            document_reference={
                "doc_id": "",
                "order_id": order_id_check,
                "item_ids": lineItemId,
                "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                "item_reference_id":formData.item_reference_id,
                "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
            }
        }else if(isDuplicateOrder){
            document_reference={
                "doc_id": "",
                "order_id": "",
                "item_ids": lineItemId,
                "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                "item_reference_id":formData.item_reference_id,
                "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
            }
        }else{
            order_id_check=(newOrderFormData && newOrderFormData.order && newOrderFormData.order.id)
            ? newOrderFormData.order.id : ""
            document_reference={
                "doc_id": (newOrderFormData && newOrderFormData._id) ? newOrderFormData._id : "",
                "order_id": order_id_check,
                "item_ids": lineItemId,
                "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                "item_reference_id": (newOrderFormData && newOrderFormData._id) ? newOrderFormData._id : formData.item_reference_id,
                "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
            }
        }
        if(status=='LabelFailed'){
            setIsFailedLabelPrinted(false)
            setDrawer(false)
            onClose(false)
            setRateDrawervisible(false)
            setNewOrderCreateDrawerVisible(false)
        }else{
            setIsFailedLabelPrinted(true)
        }
        
        const ratedata = {
            "quantity": "1",
            "referenceno": formData.sender_reference_no!=='' ? formData.sender_reference_no:referenceno,
            "preferred_service": rate_row.id,
            "fetch_rate_request_id":fetch_rate_request_id,
            "request_cheapest_carrier" : false,
            "standard_service_only": false,
            "reference": document_reference,
            "subuser_id":profile.profile.id,
            "shipment_created_method":"FETCH_RATE_CREATE_SHIPMENT"
        }
        if(isShipmentCreationFlow && document_reference && document_reference.is_failed_bulk_order && document_reference.is_failed_bulk_order===true){
            ratedata["bulk_reference_id"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.reference_id
            ratedata["internal_bulk_serial_number"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.serial_number
            ratedata["internal_bulk_serial_number_reference"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.serial_number_reference
        }
        if (customLineItems.length != 0) {
            ratedata["line_items"] = []
        }
        const mergeobjectdata = Object.assign(formData, ratedata);
        dispatch(dopostDataCreateShipment(reportName,profile.profile.id,order_id_check,mergeobjectdata, apikey, meta))
        // dispatch(generateLabel(mergeobjectdata, apikey));
        setLabelShowData(true)
        setIsLabelOpened(false);
    }

    const renderDutyTooltip = (dutyBreakdown, fallbackCurrency = "CAD") => {
        if (!dutyBreakdown || typeof dutyBreakdown !== 'object') return null;

        const elements = [];
        const actualBreakdown = Array.isArray(dutyBreakdown) ? dutyBreakdown[0] : dutyBreakdown;

        if (!actualBreakdown) return null;

        Object.entries(actualBreakdown).forEach(([key, val]) => {
            if (val === undefined || val === null || val === "" || key === "packages" || key === "details" || key === "currency_code") return;

            // Strip index numbers (e.g. "DUTY_1" -> "DUTY")
            const cleanKey = key.replace(/_\d+$/, ''); 
            
            let formattedKey = cleanKey
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.toLowerCase().slice(1))
                .join(' ');

            // Rename Zonos Markup to SC Fee
            if (formattedKey === "Zonos Markup") {
                formattedKey = "SC Fee";
            }

            let resolvedValue = null;
            let itemCurrency = fallbackCurrency;

            if (typeof val === 'object' && !Array.isArray(val)) {
                resolvedValue = val.value !== undefined ? val.value : (val.amount !== undefined ? val.amount : val.price);
                if (val.currency) itemCurrency = val.currency;
            } else if (typeof val === 'number' || !isNaN(val)) {
                resolvedValue = val;
            }

            if (resolvedValue !== undefined && resolvedValue !== null && resolvedValue !== "") {
                elements.push({
                    label: formattedKey,
                    value: parseFloat(resolvedValue).toFixed(2),
                    currency: itemCurrency
                });
            }
        });

        if (elements.length === 0) return null;

        return (
            <Box sx={{ p: 0.5 }}>
                {elements.map((item, idx) => (
                    <Box 
                        key={idx} 
                        sx={{ 
                            fontSize: '11px', 
                            color: '#ffffff', 
                            display: 'flex', 
                            alignItems: 'baseline', 
                            gap: '4px',
                            whiteSpace: 'nowrap',
                            mb: 0.5
                        }}
                    >
                        <span>{item.label}: {item.value}</span>
                        <Box component="span" sx={{ fontSize: '10px', color: '#919eab' }}>
                            {item.currency}
                        </Box>
                    </Box>
                ))}
            </Box>
        );
    };

    const isUSDProfile = profile?.profile?.currency_code === "USD";
    const currencyLabel = isUSDProfile ? 'USD' : 'CAD';

    const formatDateString = (dateStr) => {
        if (!dateStr || typeof dateStr !== 'string' || dateStr.trim() === '') return "-";

        try {
            // Extract YYYY-MM-DD from string or Date ISO output
            const cleanDateStr = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr.trim();
            const parts = cleanDateStr.split('-');

            // Ensure we have 3 valid parts (YYYY, MM, DD)
            if (parts.length === 3) {
                const [year, month, day] = parts;
                if (year && month && day) {
                    return `${day}-${month}-${year}`; // Formats to DD-MM-YYYY
                }
            }
            return "-";
        } catch (e) {
            return "-";
        }
    };

    let columns = [
        {
            field: 'service_display_name',
            headerName: 'Service Type',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row.service_display_name) {
                    return params.row.service_display_name
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'estimated_date',
            headerName: 'Estimated Date',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 130,
            resizable: false,
            renderCell: (params) => {
                const dateVal = params.row?.estimated_date;
                return formatDateString(dateVal);
            }
        },
        {
            field: 'total_charges',
            headerName: 'Shipping',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 120,
            maxWidth: 120,
            resizable: false,
            renderCell: (params) => {
                const row = params.row || {};
                const shippingValue = isUSDProfile && row.usd_total_charges !== undefined && row.usd_total_charges !== null
                    ? row.usd_total_charges
                    : row.total_charges;
                
                if (shippingValue !== undefined && shippingValue !== null && shippingValue !== "") {
                    return (
                        <Typography variant="body2" component="span" sx={{ display: 'inline-flex', alignItems: 'baseline', gap: '4px' }}>
                            <span>{parseFloat(shippingValue).toFixed(2)}</span>
                            <Box component="span" sx={{ fontSize: '11px', color: '#64748B', fontWeight: 500 }}>
                                {currencyLabel}
                            </Box>
                        </Typography>
                    );
                }
                return "-";
            }
        },
        {
            field: 'action',
            headerName: 'Label',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return <>{isFailedShipment && <div className="hide--outline"><Button disabled={orders.loading} variant="outlined"  style={{ margin: '0 15px' }} onClick={(event) => {
                    generatelabel(params.row,"LabelFailed")
                }
                }> <AddCircleOutlineOutlinedIcon style={{
                    paddingRight: '10px'
                }} /> Create </Button></div>
                }
                <div className="hide--outline"><Button disabled={orders.loading} variant="outlined" onClick={(event) => {
                    generatelabel(params.row,"LabelSuccess")
                }
                }> <AddCircleOutlineOutlinedIcon style={{
                    paddingRight: '10px'
                }} /> Create + Print </Button></div></>

            }
        }
    ];
    if(profile && profile.profile && (profile.profile.hide_carrier === false)){
        columns.splice(0, 0, {
            field: 'carrier_display_name',
            headerName: 'Carrier Name',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            renderCell: (params) => {
                if (params.row.carrier_display_name) {
                    return params.row.carrier_display_name
                } else {
                    return "-"
                }
            }
        })
    }
    if (profile && profile.profile && (
        (typeof profile.profile.is_sc_ddp_enabled !== "undefined" && profile.profile.is_sc_ddp_enabled === true) || 
        (typeof profile.profile.is_sc_myparcel_ddp_enabled !== "undefined" && profile.profile.is_sc_myparcel_ddp_enabled === true)
    )) {
        let duties_length = columns.length - 1;
        columns.splice(duties_length, 0, {
            field: 'currency_code',
            headerName: 'Duties',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 120,
            maxWidth: 120,
            resizable: false,
            renderCell: (params) => {
                const row = params.row || {};
                const isDdpEnabled = profile.profile.is_sc_ddp_enabled === true || profile.profile.is_sc_myparcel_ddp_enabled === true;
                
                const dutyData = isUSDProfile && row.usd_duty_charges ? row.usd_duty_charges : row.duty_charges;
                const breakdownData = isUSDProfile && row.usd_duty_breakdown ? row.usd_duty_breakdown : row.duty_breakdown;
                
                const totalCharge = dutyData?.total_charge;
                const hasDuties = isDdpEnabled && totalCharge !== undefined && totalCharge !== null && parseFloat(totalCharge) > 0;

                // Resolve active currency label
                const activeCurrency = isUSDProfile ? "USD" : (row.currency_code || "CAD");

                if (hasDuties) {
                    // Pass active currency to renderDutyTooltip
                    const dutyTooltipContent = renderDutyTooltip(breakdownData, activeCurrency);

                    return (
                        <Box 
                            sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                width: '100%', 
                                height: '100%',
                                gap: 0.75 
                            }}
                        >
                            <Typography variant="body2" component="span" sx={{ fontWeight: 500, display: 'inline-flex', alignItems: 'baseline', gap: '4px' }}>
                                <span>{parseFloat(totalCharge).toFixed(2)}</span>
                                <Box component="span" sx={{ fontSize: '11px', color: '#64748B', fontWeight: 500 }}>
                                    {activeCurrency}
                                </Box>
                            </Typography>
                            {dutyTooltipContent && (
                                <Tooltip title={dutyTooltipContent} placement="top" arrow>
                                    <InfoIcon 
                                        sx={{ 
                                            color: '#919eab', 
                                            fontSize: 16, 
                                            cursor: 'help',
                                            display: 'inline-block',
                                            verticalAlign: 'middle'
                                        }} 
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    );
                } else {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                            <Typography variant="body2">-</Typography>
                        </Box>
                    );
                }
            }
        });
    }

    if (
        profile && 
        profile.profile && 
        typeof profile.profile.sum_shipping_and_duties !== "undefined" && 
        profile.profile.sum_shipping_and_duties === true && (
            (typeof profile.profile.is_sc_ddp_enabled !== "undefined" && profile.profile.is_sc_ddp_enabled === true) || 
            (typeof profile.profile.is_sc_myparcel_ddp_enabled !== "undefined" && profile.profile.is_sc_myparcel_ddp_enabled === true)
        )
    ) {
        const dutiesColumnIndex = columns.findIndex(col => col.field === 'currency_code');
        
        if (dutiesColumnIndex !== -1) {
            columns.splice(dutiesColumnIndex + 1, 0, {
                field: 'shipping_and_duties_total',
                headerName: 'Total',
                headerClassName: 'super-app-theme--header',
                flex: 1,
                minWidth: 120,
                maxWidth: 120,
                resizable: false,
                renderCell: (params) => {
                    if (!params || !params.row) return "-";
                    const row = params.row;

                    const directTotal = isUSDProfile && row.usd_total !== undefined && row.usd_total !== null 
                        ? row.usd_total 
                        : row.total;

                    let finalTotal = null;

                    if (directTotal !== undefined && directTotal !== null && directTotal !== "") {
                        finalTotal = parseFloat(directTotal).toFixed(2);
                    } else {
                        let shippingCharges = 0;
                        const shippingRaw = isUSDProfile ? row.usd_total_charges : row.total_charges;
                        if (shippingRaw !== undefined && shippingRaw !== null) {
                            shippingCharges = parseFloat(String(shippingRaw).replace(/[^\d.-]/g, '')) || 0;
                        }

                        let dutyCharges = 0;
                        const dutyRaw = isUSDProfile ? row.usd_duty_charges?.total_charge : row.duty_charges?.total_charge;
                        if (dutyRaw !== undefined && dutyRaw !== null) {
                            dutyCharges = parseFloat(String(dutyRaw).replace(/[^\d.-]/g, '')) || 0;
                        }

                        finalTotal = (shippingCharges + dutyCharges).toFixed(2);
                    }

                    return (
                        <Typography variant="body2" component="span" sx={{ display: 'inline-flex', alignItems: 'baseline', gap: '4px' }}>
                            <span>{finalTotal}</span>
                            <Box component="span" sx={{ fontSize: '11px', color: '#64748B', fontWeight: 500 }}>
                                {currencyLabel}
                            </Box>
                        </Typography>
                    );
                }
            });
        }
    }
    useEffect(() => {
        if (orders && orders.notification && orders.notification.messageContent && orders.notification.messageContent[0] === 'Shipment Created Successfully' && visible == true && isLabelOpened == false && isFailedLabelPrinted==true) {
            setIsLabelOpened(true);
            setPrintUrl(orders && orders.message && orders.message.label_carrier)
            setIsPrinted(false)
            setDrawer(false)
            onClose(false)
            setRateDrawervisible(false)
            setNewOrderCreateDrawerVisible(false)
            setCustomLineItems([])
            setValues(initialFValues)
            setNewOrderFormData("")
        }
    }, [orders]);

    const getAlternateSavingsInfo = () => {
        if (!alternateLocationData) return null;

        const { 
            cheapest_location_name, 
            cheapest_location_rate, 
            origin_location_name, 
            origin_location_rate, 
            currency, 
            savings 
        } = alternateLocationData;

        const parsedSavings = parseFloat(savings);
        if (!savings || isNaN(parsedSavings) || parsedSavings <= 0) return null;

        return {
            cheapestLocationName: cheapest_location_name || "Alternate Warehouse",
            cheapestRate: cheapest_location_rate ? parseFloat(cheapest_location_rate).toFixed(2) : "0.00",
            originLocationName: origin_location_name || "Primary Warehouse",
            originRate: origin_location_rate ? parseFloat(origin_location_rate).toFixed(2) : "0.00",
            currency: currency || "CAD",
            savings: parsedSavings.toFixed(2)
        };
    };

    const savingsInfo = getAlternateSavingsInfo();
    // Reusable Savings Banner Box Component
    const SavingsBanner = () => {
        // Hide while rates or alternate rates are loading
        if (rates?.loading || rates?.alternateLocationLoading) {
            return null;
        }
        
        // Hide if rates data is missing or empty
        if (!rates?.data || !Array.isArray(rates.data) || rates.data.length === 0) {
            return null;
        }

        return savingsInfo ? (
            <Box 
                sx={{ 
                    mt: 2.5, 
                    p: 2.5, 
                    bgcolor: '#EFF6FF', 
                    border: '1px solid #BFDBFE', 
                    borderRadius: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5
                }}
            >
                {/* Header Box with flex layout to push Beta Chip to the far right */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    
                    {/* Left Side: Icon + Title & Subtitle */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box sx={{ p: 1, bgcolor: '#DBEAFE', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <DownloadOutlinedIcon sx={{ color: '#1D4ED8', fontSize: 22 }} />
                        </Box>
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1E40AF', fontSize: '14px' }}>
                                Cost Savings Opportunity Identified
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#3B82F6', fontWeight: 500 }}>
                                Cheaper fulfillment location detected for this shipment
                            </Typography>
                        </Box>
                    </Box>

                    {/* Right Side: BETA Badge */}
                    <Chip 
                        label="BETA USE ONLY" 
                        size="small" 
                        sx={{ 
                            bgcolor: '#FF9E43', 
                            color: '#FFFFFF', 
                            fontWeight: 800, 
                            fontSize: '11px', 
                            height: '24px',
                            borderRadius: '50px',
                            px: 1,
                            letterSpacing: '0.5px',
                            boxShadow: 'none',
                            border: 'none'
                        }} 
                    />
                </Box>

                <Divider sx={{ borderColor: '#BFDBFE', borderStyle: 'dashed' }} />

                <Typography variant="body2" sx={{ color: '#1E3A8A', fontSize: '13.5px', lineHeight: 1.6, fontWeight: 500 }}>
                    Save <strong>${savingsInfo.savings}</strong> by fulfilling this shipment from <strong>{savingsInfo.cheapestLocationName}</strong> instead of <strong>{savingsInfo.originLocationName}</strong>.
                </Typography>
            </Box>
        ) : null;
    };
    return (
        <>
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />
            <Drawer
                anchor="right"
                open={visible}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        ondrawerclose();
                    }
                }}
                PaperProps={{
                    sx: { width: "70%", bgcolor: '#F8FAFC' },
                }}
            >
                {/* Layout Wrapper Container */}
                <Box sx={{ p: 4, boxSizing: 'border-box' }}>
                    
                    {/* Real-time Toast Notifications Hub Component Area */}
                    {(rates && rates.notification && rates.notification.show && rates.notification.show===true) &&
                        <Notification
                            is_open={rates.notification.show}
                            messageType={rates.notification.messageType}
                            messages={rates.notification.messageContent}
                            handleClose={() => dispatch(resetRateState())}
                        />
                    }

                    {/* ==================== CONDITIONAL VIEW A: OPERATIONAL RATE INDEX LISTINGS ==================== */}
                    {(createshipment.notification.messageContent.length === 0 || createshipment.notification.messageType === 'error') &&
                        <Stack spacing={3}>
                            <Card 
                                sx={{ 
                                    backgroundColor: '#FFFFFF',
                                    border: '1px solid #E2E8F0',
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03)',
                                    overflow: 'hidden'
                                }} 
                                className="sc--cardhead--details"
                            >
                                <CardHeader 
                                    title={
                                        <Typography variant="h6" component="h1" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px', m: 0 }}>
                                            Rates
                                        </Typography>
                                    } 
                                    action={
                                        <Tooltip title="Close Panel" placement="top">
                                            <IconButton 
                                                aria-label="close" 
                                                onClick={ondrawerclose}
                                                sx={{ 
                                                    color: '#64748B', 
                                                    borderRadius: '8px', 
                                                    border: '1px solid #E2E8F0',
                                                    p: 0.75,
                                                    transition: 'all 0.15s ease-in-out',
                                                    '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B', borderColor: '#CBD5E1' }
                                                }}
                                            >
                                                <CloseIcon sx={{ fontSize: '18px' }} />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                                />
                                <Divider sx={{ borderColor: '#E2E8F0' }} />
                            </Card>
                             {/* ─── ALTERNATE LOCATION SAVINGS BANNER CARD (VIEW A) ─── */}
                            <SavingsBanner />       
                            <Card sx={{ border: '1px solid #E2E8F0', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03)' }}>
                                <DataGrid 
                                    sx={{ 
                                        width: '100%',
                                        border: 'none',
                                        backgroundColor: '#FFFFFF',
                                        
                                        // ─── 1. FORCE EXTRA BOTTOM SPACE AT THE GRID CONTAINER LEVEL ───
                                        paddingBottom: '20px !important', 

                                        '& .MuiDataGrid-main': {
                                            overflow: 'visible !important',
                                        },
                                        '& .MuiDataGrid-virtualScroller': {
                                            overflow: 'visible !important',
                                        },
                                        '& .MuiDataGrid-virtualScrollerContent': {
                                            paddingTop: '10px',
                                            paddingBottom: '20px !important', // Ensures the inner scroll area doesn't clip
                                        },

                                        '& .MuiDataGrid-topContainer': { 
                                            backgroundColor: '#F8FAFC', 
                                            '&::after': { display: 'none' } 
                                        },
                                        '& .MuiDataGrid-columnHeaders': { 
                                            backgroundColor: '#F8FAFC', 
                                            borderBottom: '1px solid #E2E8F0' 
                                        },
                                        '& .MuiDataGrid-columnHeader': { 
                                            color: '#475569', 
                                            fontWeight: 700, 
                                            fontSize: '13px', 
                                            '&:focus, &:focus-within': { outline: 'none' } 
                                        },

                                        // ─── 2. STANDARD ROW STYLING WITH EXPLICIT LAST-ROW MARGIN ───
                                        '& .MuiDataGrid-row': { 
                                            transition: 'background-color 0.15s ease-in-out', 
                                            borderBottom: '1px solid #F1F5F9 !important', 
                                            alignItems: 'center', 
                                            boxSizing: 'border-box',
                                            '&:hover': { backgroundColor: '#F8FAFC' } 
                                        },
                                        
                                        // Target the last row specifically to ensure bottom border and button spacing
                                        '& .MuiDataGrid-row:last-child': {
                                            borderBottom: '1px solid #E2E8F0 !important',
                                            marginBottom: '8px', 
                                        },

                                        '& .MuiDataGrid-cell': { 
                                            borderBottom: 'none', 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            '&:focus, &:focus-within': { outline: 'none' } 
                                        },
                                        '& .MuiLinearProgress-root': { 
                                            height: '3px', 
                                            backgroundColor: '#E2E8F0', 
                                            '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } 
                                        },

                                        // ─── 3. CHEAPEST ROW HIGHLIGHT ───
                                        '& .cheapest-row': {
                                            position: 'relative',
                                            backgroundColor: '#F0FAF0 !important',
                                            border: '1px solid #4CAF50 !important',
                                            borderRadius: '8px',
                                            '&:hover': { backgroundColor: '#EAF7EA !important' },
                                        },
                                        '& .cheapest-row::before': {
                                            content: '"★ CHEAPEST"',
                                            position: 'absolute',
                                            top: '-10px',
                                            left: '12px',
                                            backgroundColor: '#EAF7EA',
                                            color: '#2E7D32',
                                            fontSize: '10px',
                                            fontWeight: 700,
                                            letterSpacing: '0.3px',
                                            padding: '1px 6px',
                                            borderRadius: '4px',
                                            border: '1px solid #C8E6C9',
                                            zIndex: 2,
                                            lineHeight: '14px'
                                        },
                                    }}
                                    rowHeight={58} // Increased height slightly to prevent button boundary clipping
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row) => row.id}
                                    getRowClassName={(params) => {
                                        const allRows = rates?.data || [];
                                        const isCheapest = allRows.length > 1 && allRows[0]?.id === params.id;
                                        return isCheapest ? 'cheapest-row' : '';
                                    }}
                                    rows={rates?.data || []}
                                    columns={columns}
                                    columnVisibilityModel={{
                                        action: reportName === 'DASHBOARD_FETCH_RATES' ? false : true,
                                        total_charges: profile && profile.profile && profile.profile.hide_rate === true ? false : true, 
                                    }}
                                    autoHeight={true}
                                    hideFooter={true}
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                        noRowsOverlay: NorowsData
                                    }}
                                    loading={!!((rates && rates.loading) || (orders && orders.loading))}
                                />
                            </Card>
                           
                        </Stack>
                    }

                    {/* ==================== CONDITIONAL VIEW B: SUCCESSFUL LABEL CREATION RESOLUTION ==================== */}
                    {(createshipment.notification.messageContent).length !== 0 && (createshipment.notification.messageType !== 'error') &&
                        <Stack spacing={3}>
                            <Card 
                                sx={{ 
                                    backgroundColor: '#FFFFFF',
                                    border: '1px solid #E2E8F0',
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03)',
                                    overflow: 'hidden'
                                }} 
                                className="sc--cardhead--details"
                            >
                                <CardHeader 
                                    title={
                                        <Typography variant="h6" component="h1" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px', m: 0 }}>
                                            Labels
                                        </Typography>
                                    } 
                                    action={
                                        <Tooltip title="Close Panel" placement="top">
                                            <IconButton 
                                                aria-label="close" 
                                                onClick={ondrawerclose}
                                                sx={{ 
                                                    color: '#64748B', 
                                                    borderRadius: '8px', 
                                                    border: '1px solid #E2E8F0',
                                                    p: 0.75,
                                                    transition: 'all 0.15s ease-in-out',
                                                    '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B', borderColor: '#CBD5E1' }
                                                }}
                                            >
                                                <CloseIcon sx={{ fontSize: '18px' }} />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                                />
                                <Divider sx={{ borderColor: '#E2E8F0' }} />
                            </Card>

                            <Card 
                                sx={{ 
                                    backgroundColor: '#FFFFFF',
                                    border: '1px solid #E2E8F0',
                                    borderRadius: '16px',
                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                    overflow: 'hidden'
                                }} 
                                className="sc--cardhead--details"
                            >
                                <Box sx={{ p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                    
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 1.5, bgcolor: 'rgba(46, 125, 50, 0.08)', borderRadius: '50%', mb: 2 }}>
                                        <CheckCircleIcon sx={{ fontSize: '44px', color: '#2E7D32' }} />
                                    </Box>
                                    
                                    <Typography variant="h5" component="h2" sx={{ fontWeight: 800, color: '#0F172A', letterSpacing: '-0.5px', mb: 3 }}>
                                        Successfully generated label
                                    </Typography>
                                    
                                    <Stack spacing={1.5} sx={{ width: '100%', maxWith: '400px', p: 2.5, bgcolor: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '12px', mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                            <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 600, textTransform: 'uppercase' }}>Tracking Number</Typography>
                                            <Typography variant="body2" sx={{ color: '#1E293B', fontWeight: 700, fontFamily: 'monospace', fontSize: '13.5px' }}>
                                                {createshipment && createshipment.order && createshipment.order.trackingnumber}
                                            </Typography>
                                        </Box>
                                        <Divider sx={{ borderColor: '#F1F5F9' }} />
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                            <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 600, textTransform: 'uppercase' }}>Carrier</Typography>
                                            <Typography variant="body2" sx={{ color: '#1E293B', fontWeight: 700 }}>
                                                {createshipment && createshipment.order && createshipment.order.carrier_name}
                                            </Typography>
                                        </Box>
                                    </Stack>

                                    <Button 
                                        variant="contained"
                                        component="a"
                                        href={createshipment && createshipment.order && createshipment.order.label_carrier}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        startIcon={<RemoveRedEyeIcon sx={{ fontSize: '16px !important' }} />}
                                        sx={{ 
                                            textTransform: 'none', 
                                            borderRadius: '10px', 
                                            fontWeight: 700, 
                                            fontSize: '13.5px', 
                                            height: '38px', 
                                            px: 4, 
                                            boxShadow: 'none', 
                                            bgcolor: '#1976d2', 
                                            color: '#FFFFFF', 
                                            textDecoration: 'none',
                                            '&:hover': { bgcolor: '#115293', boxShadow: 'none' } 
                                        }}
                                    >
                                        View Label
                                    </Button>
                                </Box>
                            </Card>
                        </Stack>
                    }
                </Box>
            </Drawer>
        </>
    )
}


export default RateDrawer;